import { platformStorageObjectIdSchema, platformStorageSha256Schema, platformStorageUploadIntentIdSchema, } from '@crest/platform-contracts/storage';
import { z } from 'zod';
import { projectsProjectFileCategorySchema, projectsProjectFileContentTypeSchema, projectsProjectFileIdSchema, projectsProjectFileNameSchema, } from './projects-project-file.contract.js';
export const projectsCustomerPortalIntakeAcceptanceCapability = 'projects.customer-portal-intake-acceptance.v2';
export const projectsCustomerPortalIntakeAcceptanceSlot = 'customer-portal.project-intake-acceptance-actions';
export const projectsCustomerPortalIntakeAcceptanceProviderId = 'projects.server.customer-portal-intake-acceptance';
const projectsCustomerPortalIntakeTransferAssetsSchema = z.array(z.strictObject({
    assetId: z.string().uuid(),
    assetRevision: z.number().int().positive(),
    publicLinkId: z.string().uuid(),
    uploadIntentId: platformStorageUploadIntentIdSchema,
    platformObjectId: platformStorageObjectIdSchema,
    originalFileName: projectsProjectFileNameSchema,
    category: projectsProjectFileCategorySchema,
    contentType: projectsProjectFileContentTypeSchema,
    sizeBytes: z.number().int().positive().max(5 * 1_024 * 1_024 * 1_024),
    sha256: platformStorageSha256Schema,
    capturedAt: z.string().datetime({ offset: true }).nullable(),
})).max(200).superRefine((assets, context) => {
    for (const key of ['assetId', 'uploadIntentId', 'platformObjectId']) {
        if (new Set(assets.map((asset) => asset[key])).size !== assets.length) {
            context.addIssue({ code: 'custom', message: `Transferred intake ${key} values must be unique.` });
        }
    }
});
const nullableText = (maximum) => z.string().trim().min(1).max(maximum).nullable();
export const projectsCustomerPortalIntakeAcceptanceRequestSchema = z.strictObject({
    consumerModuleId: z.literal('customer-portal'),
    requestedCapability: z.literal(projectsCustomerPortalIntakeAcceptanceCapability),
    sourceCapability: z.literal('customer-portal.project-intake-requests.v1'),
    commandId: z.string().uuid(),
    projectId: z.string().uuid(),
    intakeRequestId: z.string().uuid(),
    submissionId: z.string().uuid(),
    submissionRevision: z.number().int().positive(),
    submissionHash: z.string().regex(/^[a-f0-9]{64}$/),
    incident: z.strictObject({
        incidentType: nullableText(100),
        lossTimestamp: z.string().datetime({ offset: true }).nullable(),
        cause: nullableText(200),
        affectedAreas: z.array(z.string().trim().min(1).max(100)).max(50),
        story: nullableText(5_000),
        customerName: nullableText(200),
        customerEmail: z.string().trim().email().max(320).nullable(),
        customerPhone: nullableText(50),
    }),
    assets: projectsCustomerPortalIntakeTransferAssetsSchema,
});
const projectsCustomerPortalIntakeTransferMappingsSchema = z.array(z.strictObject({
    assetId: z.string().uuid(),
    projectFileId: projectsProjectFileIdSchema,
    category: projectsProjectFileCategorySchema,
})).max(200).superRefine((mappings, context) => {
    if (new Set(mappings.map(({ assetId }) => assetId)).size !== mappings.length) {
        context.addIssue({ code: 'custom', message: 'Transferred intake assets must be unique.' });
    }
    if (new Set(mappings.map(({ projectFileId }) => projectFileId)).size !== mappings.length) {
        context.addIssue({ code: 'custom', message: 'Transferred Project files must be unique.' });
    }
});
export const projectsCustomerPortalIntakeAcceptanceResponseSchema = z.strictObject({
    state: z.literal('accepted'),
    capability: z.literal(projectsCustomerPortalIntakeAcceptanceCapability),
    tenantId: z.string().uuid(),
    projectId: z.string().uuid(),
    intakeRequestId: z.string().uuid(),
    factId: z.string().uuid(),
    idempotent: z.boolean(),
    transferredFiles: projectsCustomerPortalIntakeTransferMappingsSchema,
});
//# sourceMappingURL=projects-customer-portal-intake.contract.js.map